import { TextInput, SelectInput, BooleanInput, FormDataConsumer } from "react-admin";
import Grid from "@mui/material/Grid";

type NiyaazMemberRowFieldsProps = {
  showJamaat?: boolean;
  showRelay?: boolean;
  showWhatsApp?: boolean;
};

const gridItemSx = { minWidth: 0, maxWidth: "100%" } as const;

const compactFieldSx = {
  minWidth: 0,
  width: "100%",
  maxWidth: "100%",
  "& .MuiFormControl-root": {
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
  },
  "& .MuiInputBase-root": {
    minWidth: 0,
  },
} as const;

const selectFieldSx = {
  ...compactFieldSx,
  "& .MuiSelect-select": {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
} as const;

const toggleSx = {
  m: 0,
  mt: 0,
  mb: 0,
  "& .MuiFormControlLabel-root": {
    mx: 0,
    my: 0,
    alignItems: "center",
    gap: 0.5,
  },
  "& .MuiFormControlLabel-label": {
    lineHeight: 1.5,
  },
} as const;

export const NiyaazMemberRowFields = ({
  showJamaat = false,
  showRelay = false,
  showWhatsApp = false,
}: NiyaazMemberRowFieldsProps) => (
  <Grid container spacing={1.5} sx={{ py: 1.5, width: "100%" }}>
    <Grid size={12} sx={gridItemSx}>
      <TextInput source="name" helperText={false} fullWidth isRequired sx={compactFieldSx} />
    </Grid>
    <Grid size={{ xs: 12, sm: 5 }} sx={gridItemSx}>
      <TextInput
        source="its"
        label="ITS"
        helperText={false}
        fullWidth
        isRequired
        sx={compactFieldSx}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }} sx={gridItemSx}>
      <TextInput source="age" helperText={false} fullWidth isRequired sx={compactFieldSx} />
    </Grid>
    <Grid size={{ xs: 6, sm: 5 }} sx={gridItemSx}>
      <SelectInput
        source="gender"
        label="Gender"
        helperText={false}
        choices={[
          { id: "Male", name: "Male" },
          { id: "Female", name: "Female" },
        ]}
        fullWidth
        isRequired
        sx={selectFieldSx}
      />
    </Grid>
    {showJamaat && (
      <Grid size={{ xs: 12, sm: 6 }} sx={gridItemSx}>
        <TextInput
          source="jamaat"
          label="Jamaat"
          helperText={false}
          fullWidth
          isRequired
          sx={compactFieldSx}
        />
      </Grid>
    )}
    {showWhatsApp && (
      <Grid size={{ xs: 12, sm: showJamaat ? 6 : 12 }} sx={gridItemSx}>
        <TextInput
          source="whatsappNo"
          label="WhatsApp No."
          helperText={false}
          fullWidth
          inputProps={{ inputMode: "tel" }}
          sx={compactFieldSx}
        />
      </Grid>
    )}
    <Grid size={12} sx={gridItemSx}>
      <Grid container spacing={1.5} alignItems="center">
        <Grid size={showRelay ? 6 : 12} sx={gridItemSx}>
          <BooleanInput source="hasChair" label="Chair" options={{ size: "small" }} sx={toggleSx} />
        </Grid>
        {showRelay && (
          <Grid size={6} sx={gridItemSx}>
            <BooleanInput
              source="hasRelay"
              label="Relay"
              defaultValue={false}
              options={{ size: "small" }}
              sx={toggleSx}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
    {showRelay ? (
      <FormDataConsumer>
        {({ scopedFormData }) =>
          scopedFormData?.hasRelay === true ? (
            <Grid size={12} sx={gridItemSx}>
              <TextInput
                source="relayReason"
                label="Relay reason"
                helperText="Optional — why this person needs relay access"
                fullWidth
                multiline
                minRows={2}
                sx={compactFieldSx}
              />
            </Grid>
          ) : null
        }
      </FormDataConsumer>
    ) : null}
  </Grid>
);
